import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { AiAppDetailSectionPage } from "@/features/ai-apps/detail/ai-app-detail-section-page";

const aiAppDashboardSearchSchema = z.object({
  binSize: z.enum(["hour", "day", "week", "month"]).optional().catch(undefined),
  pointCard: z.string().optional().catch(undefined),
  pointSeries: z.string().optional().catch(undefined),
  pointInterval: z.string().optional().catch(undefined),
  pointDetails: z.coerce.boolean().optional().catch(undefined),
  trace: z.coerce.boolean().optional().catch(undefined),
  traceId: z.string().optional().catch(undefined),
  traceView: z.enum(["timeline", "table"]).optional().catch(undefined),
});

export const Route = createFileRoute("/ai-apps/$appId/dashboard")({
  component: () => <AiAppDetailSectionPage section="dashboard" />,
  validateSearch: aiAppDashboardSearchSchema,
});
